import type { RefObject } from 'react';

import { Canvas } from '../../../../core/components/canvas/Canvas.js';
import { CanvasContext } from '../../../../core/components/canvas/CanvasContext.js';
import { CanvasShape } from '../../../../core/components/canvas/types/canvas-shape.js';
import { useGridPlotSize } from '../../../../core/components/chart-grid/hooks/useGridPlotSize.js';
import { OVERLAY_PADDING } from '../../../../core/components/data-point/constants.js';
import { DataPointCanvas } from '../../../../core/components/data-point/DataPointCanvas.js';
import {
  GroupDataPoint,
  DataPoint,
} from '../../../../core/types/data-point.js';
import { useCategoricalBarChartBaseConfig } from '../../../hooks/useCategoricalBarChartBaseConfig.js';

interface CategoricalBarChartDatapointsProps {
  points?: GroupDataPoint;
  closestPoint?: DataPoint;
}

export const CategoricalBarChartDatapoints = (
  props: CategoricalBarChartDatapointsProps,
) => {
  const { width, height } = useGridPlotSize();
  const { layout } = useCategoricalBarChartBaseConfig();
  const { points, closestPoint } = props;

  return (
    <CanvasContext.Provider
      value={{
        shapeRefs: new Map<string, RefObject<CanvasShape>>(),
      }}
    >
      <Canvas
        width={width + OVERLAY_PADDING * 2}
        height={height + OVERLAY_PADDING * 2}
      >
        {points &&
          points.map((pointGroup, index) => (
            <DataPointCanvas
              key={`pointGroup-${index}`}
              valueAxis={layout === 'vertical' ? 'y' : 'x'}
              points={pointGroup}
              closestPoint={closestPoint}
            />
          ))}
      </Canvas>
    </CanvasContext.Provider>
  );
};

CategoricalBarChartDatapoints['displayName'] = 'CategoricalBarChartDatapoints';
